import type { SVGProps } from "react";

export function IconBlueBankNote(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="56" height="56" rx="28" fill="#F7F8FE" />
      <rect
        x="16"
        y="16"
        width="12"
        height="24"
        fill="#5486FA"
        stroke="#5486FA"
        strokeWidth="1.5"
      />
      <ellipse
        cx="22"
        cy="28"
        rx="4.5"
        ry="3"
        stroke="#23232C"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.25 20.25V18.75H39.0329L36.4283 26.75H42.0406L37.3739 40.75H35.7928L39.9594 28.25H35.9399L31.8701 40.75H30.2926L36.9671 20.25H30.25Z"
        fill="#23232C"
      />
    </svg>
  );
}
